import { useMutation } from "@tanstack/react-query";
import { Link, NavLink, Outlet, useLocation } from "react-router";
import { api } from "../api/cliente";
import { useDefinirSessao } from "../api/sessao";
import type { UsuarioSessao } from "../api/tipos";
import { listarFila } from "../offline/fila";
import { BotaoTema } from "./BotaoTema";
import { RodapeCreditos } from "./Creditos";

const ABAS = [
  { para: "/caixa", rotulo: "Caixa", titulo: "Caixa" },
  { para: "/vendas", rotulo: "Vendas", titulo: "Vendas" },
  { para: "/fechamento", rotulo: "Fechamento", titulo: "Fechamento" },
  { para: "/admin/eventos", rotulo: "Eventos", titulo: "Eventos", admin: true },
  { para: "/admin/produtos-estoque", rotulo: "Produtos & Estoque", titulo: "Produtos & Estoque", admin: true },
  { para: "/admin/usuarios", rotulo: "Usuários", titulo: "Usuários", admin: true },
  { para: "/admin/auditoria", rotulo: "Auditoria", titulo: "Auditoria", admin: true },
];

export function Layout({ usuario }: { usuario: UsuarioSessao }) {
  const { pathname } = useLocation();
  const definirSessao = useDefinirSessao();
  const sair = useMutation({
    mutationFn: () => api("/auth/logout", "POST", {}),
    onSettled: () => definirSessao(null),
  });
  const confirmarSaida = async () => {
    const guardadas = (await listarFila(usuario.id).catch(() => [])).length;
    if (
      guardadas > 0 &&
      !window.confirm(
        `Há ${guardadas} venda(s) guardada(s) neste aparelho ainda não enviada(s). Elas continuam guardadas e serão enviadas quando você entrar de novo neste aparelho. Sair mesmo assim?`,
      )
    ) {
      return;
    }
    sair.mutate();
  };

  const abas = ABAS.filter((a) => !a.admin || usuario.perfil === "ADMIN");
  const atual = abas.find((a) => pathname.startsWith(a.para));
  const titulo = pathname.startsWith("/perfil") ? "Meu perfil" : (atual?.titulo ?? "Master PDV Eventos");

  return (
    <div className="wrap">
      <header className="topo">
        <div className="marca">
          <small>Master PDV Eventos</small>
          <h1>{titulo}</h1>
        </div>
        <div className="usuario">
          <Link className="nome-usuario" to="/perfil" title="Meu perfil: senha e PIN" aria-label="Meu perfil">
            <svg className="icone-perfil" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <circle cx="12" cy="8" r="4" />
              <path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" />
            </svg>
            <span className="texto">
              <b>{usuario.nome}</b> · {usuario.perfil === "ADMIN" ? "Administrador" : "Operador"}
            </span>
          </Link>
          <BotaoTema />
          <button className="btn pequeno fantasma" onClick={confirmarSaida} disabled={sair.isPending}>
            Sair
          </button>
        </div>
      </header>
      <nav className="abas" aria-label="Seções">
        {abas.map((a) => (
          <NavLink key={a.para} to={a.para}>
            {a.rotulo}
          </NavLink>
        ))}
      </nav>
      <main className="pilha">
        <Outlet />
      </main>
      <RodapeCreditos />
    </div>
  );
}
